import React,{ useState, useEffect, useRef } from 'react';
import { downloadCsv, getFleetAdminDisplayName, getFleetCompanyType, labelText } from '../common/sharedFunctions';
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../components/CircularLoading";
import { api } from 'common';
import { useTranslation } from "react-i18next";
import moment from 'moment';
import {colors} from '../components/Theme/WebTheme';
import Switch from "@mui/material/Switch";
import { useNavigate,useLocation } from 'react-router-dom';
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { Box, Grid, Typography } from "@mui/material";
import localization from '../components/Table/Localization';
import { hasUserPermission } from "../common/userPermissions";
import { canDoAction, showActionPermissionDenied } from "common/src/actions/userPermissions";
import AdminDataTable from "../components/AdminDataTable";
import AdminStatusBadge from "../components/AdminStatus";
import { SectionHeader, StatusBadge, SurfaceCard } from "../components/adminPrimitives";
import adminTokens from "../styles/adminDesignTokens";


export default function Users() {
  const { t,i18n } = useTranslation();
  const isRTL = i18n.dir();
  const settings = useSelector(state => state.settingsdata.settings);
  const navigate = useNavigate();
  const {
    editUser, 
    deleteUser,
    fetchUsersOnce
  } = api;
  const [data, setData] = useState([]);
  const [sortedData, SetSortedData] = useState([]);
  const staticusers = useSelector(state => state.usersdata.staticusers);
  const dispatch = useDispatch();
    const auth = useSelector((state) => state.auth);
  const loaded = useRef(false);
  const {state} = useLocation()
  const [currentPage,setCurrentPage] = useState(null)
  
  useEffect(()=>{
    setCurrentPage(state?.pageNo)
  },[state])
  
  const HandalePageChange = (page)=>{
    setCurrentPage(page)
  }

  useEffect(()=>{
    dispatch(fetchUsersOnce());
},[dispatch,fetchUsersOnce]);

  useEffect(()=>{
    if(staticusers){
      setData(staticusers.filter(user => user.usertype ==='fleetadmin'));
    }else{
      setData([]);
    }
    loaded.current = true;
  },[staticusers]);


  useEffect(()=>{
    if(data){
      SetSortedData(data.sort((a,b)=>(moment(b.createdAt) - moment(a.createdAt))))
    }
  },[data])

  const columns = [
    { title: t('createdAt'), field: 'createdAt', editable:'never', defaultSort:'desc',render: rowData => rowData.createdAt? moment(rowData.createdAt).format('lll') :null,
        exportTransformer: (rowData) => new Date(rowData.createdAt).toLocaleDateString() + ' '+ new Date(rowData.createdAt).toLocaleTimeString()},
    { title: labelText(t, 'company_name', 'Company Name'), field: 'companyName', render: rowData => getFleetAdminDisplayName(rowData) },
    { title: labelText(t, 'company_type', 'Company Type'), field: 'companyType', render: rowData => getFleetCompanyType(rowData) },
    { title: t('mobile'), field: 'mobile', editable:'onAdd',render: rowData => settings.AllowCriticalEditsAdmin ?rowData.mobile : t("hidden_demo")},
    { title: t('email'), field: 'email', editable:'onAdd',render: rowData => settings.AllowCriticalEditsAdmin ?rowData.email : t("hidden_demo"),headerStyle:{textAlign:'center'}},
    { title: t('profile_image'),  field: 'profile_image',
    render: (rowData) =>
          rowData.profile_image ? (
            <img
              alt="Profile"
              src={rowData.profile_image}
              style={{ width: 40, height: 40, borderRadius: "50%" }}
            />
          ) : (
            <AccountCircleIcon sx={{ fontSize: 40 }} />
          ),
  },
    { title: t('account_approve'),  field: 'approved', type:'boolean', initialEditValue: true, render:rowData=>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <AdminStatusBadge status={rowData.approved ? "ACTIVE" : "PENDING"} />
        <Switch
          disabled={!settings.AllowCriticalEditsAdmin}
          checked={rowData.approved}
          onChange={() => handelApproved(rowData)}
        />
      </Box>},
  ];

  const [selectedRow, setSelectedRow] = useState(null);
  const handelApproved= (rowData) => {
    if (!canEditUser) {
      showActionPermissionDenied();
      return rowData;
    }
    const updatedUser = { ...rowData, approved: !rowData.approved };

    dispatch(editUser(updatedUser.id, updatedUser));
    dispatch(fetchUsersOnce());
    return updatedUser;
  };

  const userActionAllowed = (action) => canDoAction({
    role: auth && auth.profile && auth.profile.usertype,
    moduleKey: "users",
    action,
    accessPermissions: settings && settings.accessPermissions,
    fallback: hasUserPermission(settings, "fleetadmin", action)
  });
  const canAddUser = userActionAllowed("add");
  const canEditUser = userActionAllowed("edit");
  const canDeleteUser = userActionAllowed("delete");
  const tableActions = [
    canAddUser && {
      icon: 'add',
      tooltip: t("add_fleetadmin"),
      isFreeAction: true,
      onClick: (event) => navigate("/users/edituser/fleetadmin",{state:{pageNo:currentPage}})
    },
    canEditUser && {
      icon: 'edit',
      tooltip: t("edit"),
      onClick: (event,rowData) => navigate(`/users/edituser/fleetadmin/${rowData.id}`,{state:{pageNo:currentPage}})
    },
  ].filter(Boolean);

  return (
    !loaded.current? <CircularLoading/>:
    <Box>
      <Grid container spacing={2} sx={{ mb: 2 }}>
        <Grid item xs={12} sm={4}>
          <SurfaceCard sx={{ minHeight: 110 }}>
            <Typography sx={{ color: adminTokens.colors.muted, fontSize: 13, fontWeight: 850 }}>Fleet Admins</Typography>
            <Typography sx={{ color: adminTokens.colors.text, fontSize: "1.8rem", fontWeight: 950 }}>{sortedData.length}</Typography>
          </SurfaceCard>
        </Grid>
        <Grid item xs={12} sm={4}>
          <SurfaceCard sx={{ minHeight: 110 }}>
            <Typography sx={{ color: adminTokens.colors.muted, fontSize: 13, fontWeight: 850 }}>Approved</Typography>
            <Typography sx={{ color: adminTokens.colors.success, fontSize: "1.8rem", fontWeight: 950 }}>{sortedData.filter((item) => item.approved).length}</Typography>
          </SurfaceCard>
        </Grid>
        <Grid item xs={12} sm={4}>
          <SurfaceCard sx={{ minHeight: 110 }}>
            <Typography sx={{ color: adminTokens.colors.muted, fontSize: 13, fontWeight: 850 }}>Pending</Typography>
            <Typography sx={{ color: adminTokens.colors.warning, fontSize: "1.8rem", fontWeight: 950 }}>{sortedData.filter((item) => !item.approved).length}</Typography>
          </SurfaceCard>
        </Grid>
      </Grid>
      <SurfaceCard>
        <SectionHeader
          title={t('fleetadmins_title')}
          description="Fleet admin company accounts, contact details, profile image, approval state, and edit actions use the existing user-management workflow."
          actions={<StatusBadge tone="info">{`${sortedData.length} records`}</StatusBadge>}
        />
    <AdminDataTable
      title={t('fleetadmins_title')}
      columns={columns}
      onChangePage={(page)=>HandalePageChange(page)}
      style={{
        direction: isRTL === "rtl" ? "rtl" : "ltr",
      }}
      data={sortedData}
      emptyTitle="No fleet admins found"
      emptyDescription="No fleet admin company records are available in the current scope."
      
      onRowClick={((evt, selectedRow) => setSelectedRow(selectedRow.tableData.id))}
      options={{
        initialPage:state?.pageNo,
        exportCsv: (columns, data) => {
          let hArray = [];
          const headerRow = columns.map(col => {
            if (typeof col.title === 'object') {
              return col.title.props.text;
            }
            hArray.push(col.field);
            return col.title;
          });
          const dataRows = data.map(({ tableData, ...row }) => {
            row.createdAt = new Date(row.createdAt).toLocaleDateString() + ' '+ new Date(row.createdAt).toLocaleTimeString()
            row.companyName = getFleetAdminDisplayName(row);
            row.companyType = getFleetCompanyType(row);
            let dArr = [];
            for(let i=0;i< hArray.length; i++) {
              dArr.push(row[hArray[i]]);
            }
            return Object.values(dArr);
          })
          const { exportDelimiter } = ",";
          const delimiter = exportDelimiter ? exportDelimiter : ",";
          const csvContent = [headerRow, ...dataRows].map(e => e.join(delimiter)).join("\n");
          const csvFileName = 'download.csv';
          downloadCsv(csvContent, csvFileName);
        },
        exportButton: {
          csv: settings.AllowCriticalEditsAdmin,
          pdf: false,
        },
        maxColumnSort: "all_columns",
        rowStyle: (rowData) => ({
          backgroundColor:
            selectedRow === rowData.tableData.id ? "rgba(11, 124, 255, 0.09)" :colors.WHITE
        }),
      }}
      localization={localization(t)}
      editable={canDeleteUser ? {
        onRowDelete: oldData =>
          settings.AllowCriticalEditsAdmin?
          new Promise(resolve => {
            setTimeout(() => {
              resolve();
              dispatch(deleteUser(oldData.id));
              dispatch(fetchUsersOnce());
            }, 600);
          })
          :
          new Promise(resolve => {
            setTimeout(() => {
              resolve();
              alert(t('demo_mode'));
            }, 600);
          })
          , 


      } : {}}

      actions={tableActions}
      />
      </SurfaceCard>
    </Box>
  );
}
